import { Button, Col, Divider, Form, Input, Row, Select } from "antd";
import {
  entidadesFederativas,
  formFields,
  regimeArray,
} from "../../utils/provedorUtils";
import { useDispatch, useSelector } from "react-redux";
import {
  startPostProveedor,
  startUpdateProveedor,
} from "../../context/actions/proveedoresActions";
import { useEffect } from "react";

const TIPO_FISICA = 1;
const TIPO_MORAL = 2;

const tiposPersona = [
  { value: TIPO_FISICA, label: "Física" },
  { value: TIPO_MORAL, label: "Moral" },
];

const FormProveedor = ({ datos, onSuccess }) => {
  const dispatch = useDispatch();
  const { usuarioID } = useSelector((state) => state.userReducer.user);
  const [form] = Form.useForm();

  const selectedPerson = Form.useWatch("tipoPersona", form);

  const esFisica = selectedPerson === TIPO_FISICA;
  const esMoral = selectedPerson === TIPO_MORAL;
  const modoEdicion = Boolean(datos?.proveedorID);
  const tipoYaDefinido = Boolean(datos?.tipoPersona);

  useEffect(() => {
    if (datos?.rfc === undefined) {
      form.resetFields();
    } else {
      form.setFieldsValue(datos);
    }
  }, [datos, form]);

  const onFinishFailed = (errorInfo) => {
    console.log("Falló el envío del formulario:", errorInfo);
  };

  const onFinish = async (values) => {
    const body = {
      ...values,
      iva: Number(values.iva),
      ivaRetenido: Number(values.ivaRetenido),
      isrRetenido: Number(values.isrRetenido),
      usuarioIdCreacion: usuarioID,
    };

    if (modoEdicion) {
      body.proveedorID = datos.proveedorID;
      if (tipoYaDefinido) {
        body.tipoPersona = datos.tipoPersona;
      }
      dispatch(startUpdateProveedor(body));
      return;
    }

    const result = await dispatch(startPostProveedor(body));
    if (result.code === 0 && onSuccess) {
      onSuccess();
    }
  };

  return (
    <Form
      form={form}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      className="form-proveedor"
      layout="vertical"
    >
      <Form.Item
        label="Tipo de persona"
        name="tipoPersona"
        rules={[{ required: true, message: "Campo requerido" }]}
      >
        <Select
          options={tiposPersona}
          placeholder="Tipo de persona"
          disabled={tipoYaDefinido}
        />
      </Form.Item>

      {selectedPerson && (
        <>
          <Divider orientation="left">Información Básica</Divider>

          {esFisica &&
            formFields.fisica.map((item) => (
              <Form.Item
                key={item.label}
                label={item.label}
                name={item.value}
                rules={item.rules || []}
              >
                <Input {...item.props} />
              </Form.Item>
            ))}

          {esMoral &&
            formFields.moral.basico.map((item) => (
              <Form.Item
                key={item.label}
                label={item.label}
                name={item.value}
                rules={item.rules || []}
              >
                <Input {...item.props} type={item.type || "text"} />
              </Form.Item>
            ))}
        </>
      )}

      {selectedPerson && (
        <>
          <Divider orientation="left">Domicilio Fiscal</Divider>

          {formFields.moral.domicilio.map((item) => {
            if (item.value === "entidadFederativa") {
              return (
                <Form.Item
                  key={item.label}
                  name={item.value}
                  label={item.label}
                >
                  <Select
                    placeholder="Entidad Federativa"
                    showSearch
                    filterOption={(input, option) =>
                      (option?.label ?? "").includes(input)
                    }
                    options={entidadesFederativas}
                  />
                </Form.Item>
              );
            }
            return (
              <Form.Item
                key={item.label}
                label={item.label}
                name={item.value}
                rules={item.rules || []}
              >
                <Input {...item.props} type={item.type || "text"} />
              </Form.Item>
            );
          })}

          <Divider orientation="left">Datos de Contacto</Divider>

          <Divider orientation="left" plain>Contacto Administrativo</Divider>
          {formFields.moral.contactoAdmin.map((item) => (
            <Form.Item
              key={item.label}
              label={item.label}
              name={item.value}
              rules={item.rules || []}
            >
              <Input {...item.props} type={item.type || "text"} />
            </Form.Item>
          ))}

          <Divider orientation="left" plain>Contacto Operativo</Divider>
          {formFields.moral.contactoOperativo.map((item) => (
            <Form.Item
              key={item.label}
              label={item.label}
              name={item.value}
              rules={item.rules || []}
            >
              <Input {...item.props} type={item.type || "text"} />
            </Form.Item>
          ))}

          <Divider orientation="left">Información Fiscal</Divider>

          <Form.Item label="Régimen Fiscal" name="regimenFiscalId">
            <Select
              placeholder="Regimen"
              showSearch
              filterOption={(input, option) =>
                (option?.label ?? "").includes(input)
              }
            >
              {regimeArray.map((item) => (
                <Select.Option
                  key={item.value}
                  value={item.value}
                  label={item.label}
                >
                  {`(${item.value}) ${item.label}`}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          {formFields.moral.fiscal.map((item) => (
            <Form.Item
              key={item.label}
              label={item.label}
              name={item.value}
              rules={item.rules || []}
            >
              <Input {...item.props} type={item.type || "text"} />
            </Form.Item>
          ))}
        </>
      )}

      <Divider orientation="left">Configuración</Divider>

      <Row gutter={10}>
        <Col span={8}>
          <Form.Item name="esProveedorInterno" label="Proveedor interno">
            <Select placeholder="Proveedor interno">
              <Select.Option value={true}>Si</Select.Option>
              <Select.Option value={false}>No</Select.Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="esProveedorCritico" label="Proveedor Crítico">
            <Select placeholder="Proveedor crítico">
              <Select.Option value={true}>Si</Select.Option>
              <Select.Option value={false}>No</Select.Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Divider orientation="left">Observaciones</Divider>

      {formFields.moral.comentarios.map((item) => (
        <Form.Item key={item.label} label={item.label} name={item.value}>
          <Input.TextArea {...item.props} />
        </Form.Item>
      ))}

      <Form.Item>
        <Button type="primary" htmlType="submit">
          {modoEdicion ? "Actualizar" : "Guardar"}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default FormProveedor;